import { render, staticRenderFns } from "./studentsRecycleBin.vue?vue&type=template&id=d7e16320&scoped=true&"
import script from "./studentsRecycleBin.vue?vue&type=script&lang=js&"
export * from "./studentsRecycleBin.vue?vue&type=script&lang=js&"
import style0 from "./studentsRecycleBin.vue?vue&type=style&index=0&id=d7e16320&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7e16320",
  null
  
)

export default component.exports